import React from "react";
import i18n from "i18next";

const SearchNoResult = () => {
  return <div className="advanced-search__tile-row --no-result">{i18n.t("advancedSearch.nothing")}</div>;
};

export default SearchNoResult;



// WEBPACK FOOTER //
// ./src/components/AdvancedSearch/SearchResults/SearchNoResult.js